import {computed, type ComputedRef} from 'vue';
import {useI18n} from 'vue-i18n';
import {REGION} from '@/ts/utils/consts';

/**
 * The region the reader's account lives in, for the profiles to show rather than edit: "USA" or
 * "Europe" (IPD-3532). An account always lives in the deployment it signed up on, so the region is
 * this deployment's, whatever country an older account still carries.
 */
export function useRegionName(): ComputedRef<string> {
  const {t} = useI18n();
  return computed(() => t(REGION === 'US' ? 'region_us' : 'region_eu'));
}
